export type ItineraryDataEntry = {
    id: string;
    time: string;
    title: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    description?: string;
}

let ItineraryData: ItineraryDataEntry[] = [
    {
        id: "1",
        time: "12:30 PM",
        title: "Ceremony",
        addressLine1: "Phipps Conservatory & Botanical Gardens",
        addressLine2: "One Schenley Park, Pittsburgh, PA, 15213",
    },
    {
        id: "2",
        time: "1:00 PM",
        title: "Phipps Conservatory & Botanical Gardens Visit",
        addressLine1: "Phipps Conservatory & Botanical Gardens",
        addressLine2: "One Schenley Park, Pittsburgh, PA, 15213",
        description: "Spend time exploring our beautiful ceremony venue on us!"
    },
    {
        id: "3",
        time: "4:00 PM",
        title: "Cocktail Hour",
        addressLine1: "WBU Event Venue,",
        addressLine2: "1958 Varley St, Pittsburgh, PA 15212",
    },
    {
        id: "4",
        time: "5:00 PM",
        title: "Reception",
        addressLine1: "WBU Event Venue,",
        addressLine2: "1958 Varley St, Pittsburgh, PA 15212",
    }
];

export default ItineraryData;